require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./formation-continue-2-4.json") })
        }
      }, "path---formation-continue-2-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---formation-continue-2-4!./.cache/json/formation-continue-2-4.json
// module id = 437
// module chunks = 231608221292675